import React from 'react';
import SentenceCompletion from '~/admin/components/questions/SentenceCompletion.jsx';
export default function SentenceCompletionDemo() {
  const { buildSentenceDemo } = require('./demoData');
  const { tokens, sentence, answers } = buildSentenceDemo();
  const handleChange = (report) => {
    console.log('SentenceCompletion report', report);
    if (report && report.completedSentence) console.log('Completed:', report.completedSentence);
  };

  return (
    <div style={{ padding: 18 }}>
      <h3>Sentence Completion — Demo (using payload)</h3>
      <SentenceCompletion items={tokens} sentence={sentence} answers={answers} onChange={handleChange} />
    </div>
  );
}
